import { FC, useEffect } from "react";
import Form from "../../ui/Form";
import FormField from "../../ui/FormField";
import FormFieldsContainer from "../../ui/FormFieldsContainer";
import Input from "../../ui/Input";
import { ClaimType } from "../../../http/claimTypes/types";
import { useI18n } from "../../../hooks/useTranslations";

export interface ClaimTypeFormBody {
  name: string;
}

type ClaimTypeFormProps = {
  claimType?: ClaimType | null;
  onSubmit: (form: ClaimTypeFormBody) => Promise<void>;
  isDisabled?: boolean;
  isLoading?: boolean;
};

const ClaimTypeForm: FC<ClaimTypeFormProps> = ({ claimType, onSubmit, isDisabled, isLoading }) => {
  const i18n = useI18n();

  const defaultValues = { name: claimType?.name };

  return (
    <Form<ClaimTypeFormBody>
      defaultValues={defaultValues}
      submitText={i18n.t.common.save}
      disabled={isDisabled}
      onSubmit={() => onSubmit}
    >
      {({ register, reset, formState: { errors } }) => {
        useEffect(() => {
          reset(defaultValues);
        }, [claimType]);

        return (
          <FormFieldsContainer>
            <FormField label={i18n.t.common.name} error={errors.name}>
              {({ labelId, isInvalid }) => (
                <Input
                  id={labelId}
                  isInvalid={isInvalid}
                  disabled={isDisabled || isLoading}
                  {...register("name", {
                    required: true,
                  })}
                />
              )}
            </FormField>
          </FormFieldsContainer>
        );
      }}
    </Form>
  );
};

export default ClaimTypeForm;
